<template>
    <div class="stateHeader ml15 mr15 pl10 pt10 pb10 fs18 flex aic">
        <span class="mr10">状态:</span>  {{ formatState }}
    </div>
</template>

<script>
    export default {
        name: "hos-state-apply-detail",
        props:{
            state:{
                type:String,
                default:""
            }
        },
        computed:{
            formatState(){
                switch (this.state) {
                    case "WAIT_EXAMINE" :
                        return "待审核"
                    case "FINSH" :
                        return "已安排"
                    case "REFUSED" :
                        return "拒绝转诊"
                    case "CANCEL" :
                        return "取消申请"
                }
                return ''
            }
        }
    }
</script>

<style lang="scss" scoped>
.stateHeader{
    height: 40px;
    font-family: PingFangSC-Medium;
    color: #3692F9;
    background: #E6F1FC;
}
</style>